import React from 'react';

// Clickable amber alert — jumps to the wizard step that still needs input.
export default function WizardBlockerCard({ blocker, onGoToStep, testId = 'wizard-go-to-step' }) {
  if (!blocker || !onGoToStep) return null;

  return (
    <button
      type="button"
      data-testid={testId}
      onClick={() => onGoToStep(blocker.step)}
      style={cardStyle}
      aria-label={`Go to step ${blocker.step}: ${blocker.stepLabel}`}
    >
      <AlertCircleIcon />
      <span style={bodyStyle}>
        <span style={titleStyle}>{blocker.title}</span>
        <span style={detailStyle}>
          {blocker.detail}
          {' · '}
          <span style={stepStyle}>Step {blocker.step} · {blocker.stepLabel}</span>
        </span>
      </span>
      <ChevronIcon />
    </button>
  );
}

function AlertCircleIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" style={{ flexShrink: 0, color: 'var(--amber-strong)' }}>
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.75" fill="none" />
      <path d="M12 8v5M12 16h.01" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  );
}

function ChevronIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" style={{ flexShrink: 0, color: 'var(--muted)' }}>
      <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

const cardStyle = {
  width: '100%',
  display: 'flex',
  alignItems: 'flex-start',
  gap: '14px',
  padding: '16px 18px',
  borderRadius: '12px',
  textAlign: 'left',
  fontFamily: 'var(--font)',
  cursor: 'pointer',
  background: 'var(--amber-bg)',
  border: '1px solid rgba(245, 158, 11, 0.35)',
  boxShadow: 'var(--shadow-sm)',
  transition: 'border-color 120ms ease, box-shadow 120ms ease, background 120ms ease',
};

const bodyStyle = { display: 'flex', flexDirection: 'column', gap: '4px', flex: 1, minWidth: 0 };
const titleStyle = { fontSize: '15px', fontWeight: 600, color: 'var(--ink)' };
const detailStyle = { fontSize: '13px', lineHeight: 1.5, color: 'var(--ink2)' };
const stepStyle = { color: 'var(--amber-strong)', fontWeight: 500 };
